import styled, { css } from 'styled-components';
import { Button } from '@hud/web-components/Button/Button';
import { themeColor } from '@hud/web-components/theme/colors';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import { transitionFunc } from '@hud/web-components/theme/utils';
import {
  lgBold,
  smLight,
  xxsRegular,
  xxxsRegular,
} from '@hud/web-components/theme/typography';
import Background from './extension_banner_bg.png';

export const CloseIcon = styled(HudIcon)`
  position: absolute;
  top: 10px;
  right: 8px;
  transition: transform 0.2s ${transitionFunc};

  color: ${themeColor('textPrimary')};

  cursor: pointer;

  &:hover {
    transform: scale(1.2);
  }
`;

export const DontShowAgainButton = styled(Button)`
  ${xxxsRegular};
  text-decoration: underline;
  position: absolute;
  top: 36px;
  right: 10px;
  color: ${themeColor('textSecondary')};
`;

export const Title = styled.div`
  ${lgBold};
  color: ${themeColor('textPrimary')};
  white-space: nowrap;

  em {
    background: linear-gradient(92deg, #F9BAF9 0%, #9470FD 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-style: normal;
  }
`;

const dotDivider = css`
  &:before {
    position: relative;
    content: '•';
    top: -1px;
    padding-right: 6px;
    text-decoration: none;
    display: inline-block; //required to disable text-decoration
    pointer-events: none;
    font-size: 10px;
    opacity: 0.6;
  }
`;

export const Subtitle = styled.div`
  ${smLight};
  color: ${themeColor('textPrimary')};
  white-space: nowrap;
  margin-bottom: 8px;

  & > span:not(:first-child) {
    margin-left: 6px;
    ${dotDivider};
  }
`;

export const Content = styled.div`
  padding: 24px 24px 24px;
  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 8px;

  min-width: 720px;
`;

export const Container = styled.div`
  position: relative;
  border: 1px solid transparent;
  display: flex;
  border-radius: 8px;
  z-index: 0;
  margin-top: 12px;

  width: calc(100% - 2px);

  &:before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    width: calc(100% + 1px);
    height: calc(100% + 1px);
    border-radius: 4px;
    background: linear-gradient(-200deg, #b65aff, #0ffee6);
    z-index: -2;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: calc(100% - 1px);
    height: calc(100% - 1px);
    background: url(${Background}), linear-gradient(0deg, rgba(53, 60, 89, 1) 0%, rgba(45, 46, 58, 1) 100%);
    background-position: bottom -90px right -70px, center;
    background-repeat: no-repeat;
    box-shadow: 4px 6px 13.2px 0px rgba(0, 0, 0, 0.25);
    z-index: -1;
    border-radius: 4px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const StyledButton = styled(Button)`
  ${xxsRegular};
  padding: 6px 10px;
  display: flex;
  gap: 4px;
  span {
    margin-right: 8px;
  }

  .vsc {
    margin-left: 4px;
  }

  .windsurf {
    margin-left: -4px;
  }
`;
